module.exports = __webpack_public_path__ + "static/img/xz2.f9eb94d2.png";